const compareProducts = {
    ADD_COMPARE_PRODUCTS: "ADD_COMPARE_PRODUCTS",
    REMOVE_COMPARE_PRODUCTS: "REMOVE_COMPARE_PRODUCTS",
    DELETE_ALL_COMPARE_PRODUCTS: "DELETE_ALL_COMPARE_PRODUCTS"
};

export default compareProducts;